import React, { useContext, useEffect, useState } from "react";
import "./dashBoard.css";
import { DashBoardContext } from "../DashBoardView";
import MfaPopup from "../../../components/MfaPopup/MfaPopup";
const DashBoard = () => {
  // useEffect(() => {
  //   setMfaPop(true);
  // }, []);

  const {} = useContext(DashBoardContext);
  return <div></div>;
};

export default DashBoard;
